import React, { useEffect, useRef } from "react"
import styled from "styled-components"
import { motion, AnimatePresence } from "framer-motion"

import CarouselSelectionOptions from "./CarouselSelectionOptions"

const Selection = CarouselSelectionOptions

const Container = styled.div`
  overflow-y: scroll;
`

const Animated = ({children}: {children: JSX.Element}) => {
  return (
    <motion.div
      style={{ transformOrigin: "top center" }}
      animate={{ opacity: 1, scale: 1 }}
      initial={{ opacity: 0, scale: 0.95 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.5, type:"tween", ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  )
}

type TabProps = {
  children: JSX.Element
}

const Body = (props: TabProps, key: string) =>
  <Animated key={key}>
    {props.children}
  </Animated>


type Props = {
  left: JSX.Element
  center: JSX.Element
  right: JSX.Element
  selected: CarouselSelectionOptions
}

const CarouselBody = ({left, center, right, selected}: Props) => {
  const scrollContainer = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (scrollContainer.current !== null)
      scrollContainer.current.scrollTo({top:0, behavior:"smooth"})
  }, [selected])
  
  return (
    <Container ref={scrollContainer}>
      <AnimatePresence exitBeforeEnter>
        { selected === Selection.LEFT &&
          <Body key="left">
            {left}
          </Body>
        }

        { selected === Selection.CENTER &&
          <Body key="center">
            {center}
          </Body>
        }

        { selected === Selection.RIGHT &&
          <Body key="right">
            {right}
          </Body>
        }
      </AnimatePresence>
    </Container>
  )
}

export default CarouselBody